import React from 'react'
import { Tilt } from 'react-tilt'
import {motion} from 'framer-motion'
import {styles} from '../styles'
import {fadeIn, fadels, textVariant} from '../utils/motion'

const ServiceCard = ({title, icon, index}) => {
  return (
    <Tilt className="xs:w-[250px] w-full">
    <motion.div variants={fadeIn("right", "spring", 0.5*index,0.75)}
    className='w-full green-pink-gradient p-[1px] rounded-[20px] shadow-card'>
      <div
      options={{
        //these options are for the movement of the card
        max:45,
        scale: 1,
        speed: 450
      }}
      className='bg-tertiary rounded-[20px] py-5 px-12 min-h-[280px] flex justify-evenly items-center flex-col'>
        <img src={icon} alt={title} className='w-20 h-20 object-contain' />
        <h3 className='text-white font-bold text-center text-[20px]'>{title}</h3>
      </div>
    </motion.div>
  </Tilt>
  )
}

export default ServiceCard